import { inject, Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { GET_OFFERS, USER_ACCOUNT } from '../../shared/config/app.config'
import { UserAccountFacade } from '@spartacus/user/account/root';
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { concatMap, EMPTY, filter, map, Observable } from 'rxjs';
import { Offer } from '../models/offers.model';
import { OffersAcceptanceResponse, OffersPayload } from '../models/offers-form.model';

@Injectable({
  providedIn: 'root'
})
export class MyOffersService {

  private readonly baseService = inject(BaseService);
  private readonly userAccountFacade = inject(UserAccountFacade);
  private readonly customProfileAndPreferencesService = inject(CustomProfileAndPreferencesService);

  readonly b2bUser$ = this.customProfileAndPreferencesService._userAccountData;

  readonly user$ = this.userAccountFacade.get();

  readonly offers$ = this.userAccountFacade.get().pipe(
    filter((user) => !!user),
    concatMap((user) => {
      const location = JSON.parse(sessionStorage.getItem('selectedLocations'));
      if (location === null || location.length === 0) {
        // User didn't choose a location yet. Nothing will be emitted.
        return EMPTY;
      }
      const id = location[0].accountNumber;
      return this.baseService.get(`/users/${user.uid}/${GET_OFFERS}/${id}`).pipe(
        map(res => res.offers as Offer[])
      );
    }),
  );

  confirmOffer(offerPayload: OffersPayload) {
    return this.userAccountFacade.get().pipe(
      concatMap((user) => {
        const location = JSON.parse(sessionStorage.getItem('selectedLocations'));
        if (location === null) {
          return EMPTY;
        }
        const id = location[0].accountNumber;
        const apiEndpoint = `${USER_ACCOUNT}${user.uid}/offers/group/loader/${id}`;
        return <Observable<OffersAcceptanceResponse>>this.baseService.post(apiEndpoint, offerPayload);
      })
    );
  }
}
